export default class People {

  constructor(options) {
    this._http = options.http
  }

  async status() { return this._http.getWs('/control/people/status') }
  async enable(enabled) { return (await this._http.post('/control/people/enable', { enabled })).data }
  async pause(paused) { return (await this._http.post('/control/people/pause', { paused })).data }
  async analyze(operation) { return (await this._http.post(`/control/people/analyze/${operation}`)).data }
  async rematch() { return (await this._http.post('/control/people/rematch')).data }
  async cancelRematch(id) { return (await this._http.post(`/control/people/rematch/${id}/cancel`)).data }
  async rematchFaces() { return (await this._http.post('/control/people/rematch/faces')).data }
  async cancelFaceRematch(id) { return (await this._http.post(`/control/people/rematch/faces/${id}/cancel`)).data }
  async generateAgingVideo(personId, options) {
    return (await this._http.post(`/control/people/persons/${personId}/aging-video`, options)).data
  }
  async cancelAgingVideo(id) {
    return (await this._http.post(`/control/people/aging-video/${id}/cancel`)).data
  }
  agingVideoDownloadUrl(id) {
    return `${this._http.defaults?.baseURL || ''}/control/people/aging-video/${id}/download`
  }
  async failures(offset=0, limit=50) {
    return this._http.getWs(`/control/people/failures?offset=${offset}&limit=${limit}`)
  }

  async persons(status, offset=0, limit=50, search='') {
    const query = search ? `&search=${encodeURIComponent(search)}` : ''
    return this._http.getWs(`/control/people/persons?status=${encodeURIComponent(status)}&offset=${offset}&limit=${limit}${query}`)
  }

  async targets() {
    return this._http.getWs('/control/people/targets')
  }

  async person(id, offset=0, limit=100) {
    return this._http.getWs(`/control/people/persons/${id}?offset=${offset}&limit=${limit}`)
  }

  async faces(state, offset=0, limit=100, sort='newest') {
    return this._http.getWs(`/control/people/faces?state=${encodeURIComponent(state)}&offset=${offset}&limit=${limit}&sort=${sort}`)
  }

  async unassignedFaces(offset=0, limit=100, sort='newest') {
    return this._http.getWs(`/control/people/faces?unassigned=true&offset=${offset}&limit=${limit}&sort=${sort}`)
  }

  async mediaFaces(mediaId) {
    return this._http.getWs(`/control/people/media/${mediaId}/faces`)
  }

  async confirm(person, name) {
    return (await this._http.post(`/control/people/persons/${person.id}/confirm`, {
      name,
      expected_version: person.version,
    })).data
  }

  async update(person, changes) {
    return (await this._http.patch(`/control/people/persons/${person.id}`, {
      ...changes,
      expected_version: person.version,
    })).data
  }

  async move(faceIds, person) {
    return (await this._http.post('/control/people/faces/move', {
      face_ids: faceIds,
      person_id: person?.id ?? null,
      expected_person_version: person?.version,
    })).data
  }

  async ignore(faceIds) {
    return (await this._http.post('/control/people/faces/ignore', { face_ids: faceIds })).data
  }

  async createDraft(faceIds, name) {
    return (await this._http.post('/control/people/persons/draft', { face_ids: faceIds, name })).data
  }

  async createUnconfirmed(faceIds) {
    return (await this._http.post('/control/people/persons/unconfirmed', { face_ids: faceIds })).data
  }

  async split(person, faceIds) {
    return (await this._http.post(`/control/people/persons/${person.id}/split`, {
      face_ids: faceIds,
      expected_version: person.version,
    })).data
  }

  async merge(target, sources, confirmedMerge) {
    const people = [target, ...sources]
    return (await this._http.post('/control/people/merge', {
      target_id: target.id,
      source_ids: sources.map(person => person.id),
      expected_versions: Object.fromEntries(people.map(person => [person.id, person.version])),
      confirmed_merge: confirmedMerge,
    })).data
  }

  async hide(people) {
    return (await this._http.post('/control/people/hide', {
      person_ids: people.map(person => person.id),
      expected_versions: Object.fromEntries(people.map(person => [person.id, person.version])),
    })).data
  }

  async actions() { return this._http.getWs('/control/people/actions') }
  async undo(actionId) { return (await this._http.post(`/control/people/actions/${actionId}/undo`)).data }
  async erase() {
    return (await this._http.delete('/control/people/data', { data: { confirmation: 'erase people data' } })).data
  }
}
